import { NgoPartnerDto } from './../../../models/trofaco/ngoPartnerDto';
import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { PlantingSiteDto } from '../../../models/trofaco/plantingSiteDto';
import { PlantingSiteDetailDto } from '../../../models/trofaco/plantingSiteDetailDto';
import { speciesDto } from '../../../models/trofaco/speciesDto';
import { PlantingSiteAreaDto } from 'src/app/models/trofaco/plantingSiteAreaDto';
import { PlantingSiteSpeciesDto } from 'src/app/models/trofaco/plantingSiteSpeciesDto';
import { CertificateDto } from 'src/app/models/trofaco/certificateDto';
import { throwError } from 'rxjs';
import { CsvDto } from 'src/app/models/trofaco/csvDto';


@Injectable({
    providedIn: 'root'
})
export class TreeSpeciesService {

    constructor(private requestService: RequestService) {
    }

    async getAllSpecies(): Promise<speciesDto[]> {
        let result = await this.requestService.getApi<speciesDto[]>('treespecies');
        return result.data;
    }

    async getPlantingSiteSpecies(id: string): Promise<string> {
        let result = await this.requestService.getApi<string>('treespecies/plating-species/' + id);
        return result.data;
    }

    async saveSpecies(species: PlantingSiteSpeciesDto, plantingSiteId: string): Promise<string> {
        let data = {
            speciesId : species.speciesId,
            count: species.count,
            species: species.species,
            description : species.description
        };

        if (species.id) {
            await this.requestService.patch('plantingSites/update-planting-site-species', { id: species.id, ...data });
            return species.id;
        } else {
            let result = await this.requestService.post('plantingSites/create-planting-site-species', { plantingSiteId: plantingSiteId, ...data });
            return result.data;
        }
    }

    async deleteSpecies(id: string): Promise<string> {
        let result = await this.requestService.delete('treespecies/delete?id=' + id);
        return result.data;
    }

    async createSpeies(species: PlantingSiteSpeciesDto): Promise<speciesDto> {
        let data = {
            species: species.species,
            description : species.description
        };
        let result = await this.requestService.post('treespecies/create-species',{...data});
        return result.data;
    }

    async updateSpeies(species: PlantingSiteSpeciesDto): Promise<speciesDto> {
        let data = {
            id: species.id,
            species: species.species,
            description : species.description
        };
        let result = await this.requestService.post('treespecies/create-species',{...data});
        return result.data;
    }
}
